<div class="row">
    <div class="col-md-6">

        <nb-card>
            <nb-card-header>
                {{title}}
            </nb-card-header>
            <nb-card-body>
                <div class="text-center" id="manageErrMsg" style="display:none; color: red;padding:0 0 20px 0;"></div>
                                    
                <form [formGroup]="manageForm" class="form-valide">
                    <div class="form-group">
                        <label for="oldPassword" class="label">Old Password</label>
                        <input type="password" nbInput fullWidth id="oldPassword" formControlName="oldPassword" fieldSize="small" [status]="(submitted && f.oldPassword.errors) ?'danger' : 'basic'">
                        <ng-container *ngIf="submitted && f.oldPassword.errors" class="invalid-feedback">
                            <p class="caption status-danger" *ngIf="f.oldPassword.errors.required">Old password is required</p>
                        </ng-container>
                    </div>
                    <div class="form-group">
                        <label for="newPassword" class="label">New Password</label>
                        <input type="password" nbInput fullWidth id="newPassword" formControlName="newPassword" fieldSize="small" [status]="(submitted && f.newPassword.errors) ?'danger' : 'basic'">
                        <ng-container *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                            <p class="caption status-danger" *ngIf="f.newPassword.errors.required">New password is required</p>
                            <p class="caption status-danger" *ngIf="f.newPassword.errors.pattern">Password must have atleast 8 characters including one lowercase,uppercase,number and special character</p>
                        </ng-container>
                    </div>
                    <div class="form-group">
                        <label for="confirmPassword" class="label">Confirm Password</label>
                        <input type="password" nbInput fullWidth id="confirmPassword" formControlName="confirmPassword" fieldSize="small" [status]="(submitted && f.confirmPassword.errors) ?'danger' : 'basic'">
                        <ng-container *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                            <p class="caption status-danger" *ngIf="f.confirmPassword.errors.required">Confirm password is required</p>
                            <p class="caption status-danger" *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</p>
                        </ng-container>
                        <small>Note: You will have to re-login after successfull reset of password</small>
                        
                    </div>
                    <div class="buttons-row float-right">
                        <button type="button" (click)="onSubmitManageForm()" class="appearance-filled" [size]="'small'"
                            [status]="'success'" nbButton>Save</button>
                        <button type="button" (click)="onReset()" class="appearance-outline" [size]="'small'"
                            [status]="'info'" nbButton>Reset</button>
                    </div>
                    
                </form>
            </nb-card-body>
        </nb-card>

        
    </div>
</div>